import React from "react";
import { productPropertyTypeChips } from "../../utils/complexBtlProduct.js";

export default function PropertyTypeChips({ product, compact = false, omitKeys = [] }) {
  const omit = new Set(omitKeys);
  const chips = productPropertyTypeChips(product).filter((chip) => !omit.has(chip.key));
  if (!chips.length) return null;
  return chips.map((chip) => (
    <span
      key={chip.key}
      className={
        `inline-flex shrink-0 items-center rounded-full border font-semibold whitespace-nowrap ${chip.tone} ` +
        (compact ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs")
      }
    >
      {chip.label}
    </span>
  ));
}
